import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    window.dispatchEvent(new Event("cookie_consent_changed"));
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie_consent", "declined");
    // Disable Google Analytics if declined
    window['ga-disable-G-QMHQT6CQTE'] = true;
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-neutral-900 border border-neutral-800 rounded-2xl p-6 shadow-2xl">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-[#B8960B]/20 flex items-center justify-center">
                  <Cookie className="text-[#B8960B]" size={24} />
                </div>
              </div>
              
              <div className="flex-grow">
                <h3 className="font-semibold text-white mb-1">We use cookies</h3>
                <p className="text-sm text-neutral-400">
                  We use cookies to enhance your browsing experience and analyse our traffic. 
                  By clicking "Accept All", you consent to our use of cookies. 
                  Read our <Link to="/cookies" className="text-[#B8960B] hover:underline">Cookie Policy</Link> for more information.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
                <Button
                  variant="outline"
                  onClick={declineCookies}
                  className="btn-secondary rounded-full px-6 text-sm"
                >
                  Decline
                </Button>
                <Button
                  onClick={acceptCookies}
                  className="btn-primary rounded-full px-6 text-sm"
                >
                  Accept All
                </Button>
              </div>

              <button
                onClick={declineCookies}
                className="absolute top-4 right-4 md:hidden text-neutral-500 hover:text-white"
              >
                <X size={20} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
